import { Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import {
    addListaMunicipiosDescarregamento,
    removeListaMunicipioDescarregamento,
    removeListaMunicipioDescarregamentoTodos
} from "../../../features/manifestoSlice";
import NFes from "./NFe/NFes";
import CTes from "./CTe/CTes";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead, JvCaption } from "../../../components/Components";
import { infMunDescargaInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4, goToFocus } from "../../../utils/utils";
import MDFes from "./MDFe/MDFes";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const limite = 100;

export default function InfDocumentos(props: any) {
    const dispatch = useDispatch();
    const munDescarga = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const selectMunicipiosCarregamento = useSelector((state: RootState) => state.manifesto.selectMunicipiosCarregamentos);
    const munDescargaSelectRef = useRef<HTMLSelectElement>(null);
    const form = useSelector((state: RootState) => state.manifesto.manifesto);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const [saldo, setSaldo] = useState<number>(0);
    const handleAdd = () => {

        const value = munDescargaSelectRef?.current?.value || ''

        if (value === "") {
            alertModal('Na aba Principal, selecione uma UF Final para carregar os municípios.');
            return;
        }

        const nomeMunicipio = munDescargaSelectRef.current?.options[munDescargaSelectRef.current?.selectedIndex].text ||
            '';

        if (munDescarga.find(item => item.municipio_id === parseInt(value))) {
            goToFocus(munDescargaSelectRef);
            alertModal('Município já adicionado.');
            return;
        }

        if (form.indcarregaposterior) {

            if (munDescarga.length >= 1) {
                alertModal(
                    'Não é permitido adicionar mais de um município quando Ind. Carregamento Posterior estiver marcado.'
                );
                return;
            }


            if (form.infMunCarrega.length > 0) {
                if (form.infMunCarrega[0].municipio_id.toString() !== value) {
                    alertModal('O município de descarregamento de ser igual ao município de carregamento.');
                    return;
                }
            }
            if (form.infMunCarrega.length === 0) {
                alertModal('Informe primeiramente o município de carregamento');
                return;
            }

        } else {

            if (munDescarga.length >= 100) {
                alertModal('Número máximo de municípios atingido.');
                return;
            }
        }


        dispatch(addListaMunicipiosDescarregamento(
            {
                id: getUuidV4(),
                municipio_id: parseInt(value),
                name: nomeMunicipio
            }
        ))
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        let obs: React.ReactNode;
        if (munDescarga.length > 0) {
            setSelecionado(value.id);
            const totalMdfes = munDescarga
                .filter(item => item.id.toString() === value.id.toString())
                .flatMap((item) => item.infMDFe).length ?? 0;
            const totalCTes = munDescarga
                .filter(item => item.id.toString() === value.id.toString())
                .flatMap((item) => item.infCTe).length ?? 0;
            const totalNFes = munDescarga
                .filter(item => item.id.toString() === value.id.toString())
                .flatMap((item) => item.infNFe).length ?? 0;
            const total = totalCTes + totalMdfes + totalNFes;
            if (total > 0)
                obs = <><strong
                    className="text-danger fw-bold text-center">
                    Obs: Existe(m) documento(s) fiscal(is) vinculado(s) ao município que será(ão) removido(s)! <br />
                </strong></>;

            const confirmed = await confirm({
                message: <>{obs}
                    <div className={`${total > 0 ? 'text-center' : ''}`}>
                        Deseja realmente remover <strong>{value.title}</strong> ?
                    </div></>,
                title: "Confirmação"
            })
            
            if (confirmed) {
                dispatch(removeListaMunicipioDescarregamento(value.id));
            }
            setSelecionado('');
        }
    }

    const removerTudo = async () => {
        if (munDescarga.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos os municípios ?</>,
                title: "Confirmação"
            });
            
            if (confirmed) {
                dispatch(removeListaMunicipioDescarregamentoTodos());
            }
        }
    }

    useEffect(() => {
        setSaldo(munDescarga.length);
    }, [munDescarga])


    return (<div className="px-2">

        <Tabs defaultActiveKey="tab_municipio_descarregamento" id="tab-example" className="mb-2">
            <Tab eventKey="tab_municipio_descarregamento" title="Municípios de descarregamento">
                <Card className="mb-2">
                    <Card.Header className="fw-bold">
                        Municípios
                    </Card.Header>
                    <Card.Body>

                        <Row className="g-2 mb-2">
                            <Col md={3}>
                                <Form.Group controlId="municipio_descarregamento">
                                    {/* <Form.Label>Municípios</Form.Label> */}
                                    <div className="input-group">

                                        <Form.Select name="municipio_descarregamento"
                                            ref={munDescargaSelectRef} >
                                            {selectMunicipiosCarregamento?.map((municipio: any) => (
                                                <option
                                                    key={municipio.id} selected={municipio.capital === 1}
                                                    value={municipio.id}>
                                                    {municipio.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Button variant="primary" onClick={handleAdd}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </div>
                                </Form.Group>

                            </Col>

                        </Row>
                    </Card.Body>
                </Card>



                <JTable >
                    <JvCaption>({saldo} de {limite} no máximo)</JvCaption>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>
                                <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                            </th>
                            <th>Município</th>
                        </tr>
                    </JTHead>
                    <JTBody>
                        {munDescarga?.map((item: infMunDescargaInterface) => {
                            return (
                                <tr key={item.id}
                                    className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                    <td className="text-center">
                                        <ButtonRemover onClick={() => {
                                            handleRemover({ id: item.id.toString(), title: item.name })
                                        }
                                        } />
                                    </td>
                                    <td>{item.name}</td>
                                </tr>
                            );
                        })}
                    </JTBody>
                </JTable>
            </Tab>

            <Tab eventKey="tab_md_nfe" title="Nota Fiscal Eletrônica (NF-e)" className="scroll-responsive">
                <NFes />
            </Tab>

            {props.showDocumentoConhecimento && (
                <Tab eventKey="tab_md_cfe" title="Conhecimento Eletrônico (CT-e)" className="scroll-responsive">
                    <CTes />
                </Tab>
            )}

            {props.showDocumentoManifesto && (
                <Tab eventKey="tab_md_mdfe" title="Manifesto Eletrônico de Documento (MDF-e)"
                    className="scroll-responsive">
                    <MDFes />
                </Tab>
            )}
        </Tabs>
        {ConfirmModal}
        {ModalMessageEl}
    </div>);

}
